import { travel, axiosConfig } from 'api';

export interface BreakRulesReason {
  id: string;
  name: string;
}

export interface BreakRulesReasonResponse {
  data: BreakRulesReason[];
}

export const getBreakRulesReasonForTravel = (): Promise<BreakRulesReasonResponse> =>
  travel.get('/Travels/GetBreakRulesReasons', axiosConfig).then((response) => response.data);
